import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import { previewHistoryBatch } from '../../../../store/extensions';
import SliderRangeListItem from '../../../../../../list-items/SliderListItem/SliderRangeListItem';
import { DEFAULT_PARTICLES_FLICKERING_SETTINGS } from '../../../../CreatePageConstants';

// 318.31 was derived from 100 / maxFlickerSpeed (3 flickers per second = 3 * 2PI / 60)
const codeToUI = (codeValue) => Math.round(codeValue * 318.31);
const uiToCode = (uiValue) => Number((uiValue / 318.31).toFixed(4));

const ParticlesFlickeringIntensityListItem = (props) => {
    const { index, updateParticleElement, minIntensity, maxIntensity, enabled, reactive } = props;

    const onFlickeringIntensityChange = (value) => {
        previewHistoryBatch.start();
        updateParticleElement(index, { 
            flickering: {
                enabled,
                reactive,
                minIntensity: uiToCode(value[0]), 
                maxIntensity: uiToCode(value[1])
            }
        });
    };

    return (
        <SliderRangeListItem
            title='Flicker Speed'
            value={[codeToUI(minIntensity), codeToUI(maxIntensity)]}
            displayMultiplier={1}
            min={1}    
            max={100}  
            step={1}   
            onValueChange={onFlickeringIntensityChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const particleElement = state.createPreview.present.videoSettings.elements.particles.items[ownProps.index];
    const flickering = particleElement.flickering;

    return {
        minIntensity: flickering?.minIntensity ?? DEFAULT_PARTICLES_FLICKERING_SETTINGS.minIntensity,
        maxIntensity: flickering?.maxIntensity ?? DEFAULT_PARTICLES_FLICKERING_SETTINGS.maxIntensity,
        enabled: flickering?.enabled ?? DEFAULT_PARTICLES_FLICKERING_SETTINGS.enabled,
        reactive: flickering?.reactive ?? DEFAULT_PARTICLES_FLICKERING_SETTINGS.reactive
    };
}

const mapDispatchToProps = (dispatch) => ({
    updateParticleElement: (index, properties) => dispatch(createActions.updateParticleElement(index, properties))
});

export default connect(mapStateToProps, mapDispatchToProps)(ParticlesFlickeringIntensityListItem);